/* eslint-disable */
// @ts-nocheck

import { CSRF } from '../helpers/csrf';

export function initMain() {
	document.addEventListener('ajaxSend', function (event) {
		var isCSRFrequired = function (type) {
			return /^POST|PATCH|PUT|DELETE$/i.test(type);
		};

		if (!isCSRFrequired(event.detail.type)) {
			return;
		}

		event.detail.request.setRequestHeader('X-CSRF-Token', CSRF);

		if (
			event.detail.type === 'POST' &&
			event.detail.settings.data &&
			typeof event.detail.settings.data.replace === 'function'
		) {
			event.detail.settings.data = event.detail.settings.data.replace(/\(/g, '%28');
			event.detail.settings.data = event.detail.settings.data.replace(/\)/g, '%29');
		}
	});

	const initClickOutsideDropdown = () => {
		document.body.addEventListener('click', function (e) {
			if (
				e.target.nodeName !== 'A' &&
				document.querySelector('.cta-main-container li.show')
			) {
				document.querySelector('.cta-main-container li.show').classList.remove('show');
			}

			// Close shopping cart dropdown
			if (!e.target.closest('#shoppingCart')) {
				const shoppingCart = document.getElementById('shoppingCart');
				if (shoppingCart) {
					shoppingCart.classList.remove('active');
				}
			}
		});
	};

	initClickOutsideDropdown();
}

/*
 * This function was extracted from toolbarhelper.ts (which replaces toolbarhelper.js) to initialize CF dropdowns.
 * TODO: Remove this code after refactoring the collections dropdown into react.
 */
export function initCollectionsDropdown() {
	let dropdownElement = document.querySelector('.cta-main-container a.cta-dropdown-trigger');

	if (dropdownElement) {
		initDropdown(dropdownElement);
	} else {
		// For some reason although the element is loaded from CF, it is randomly not found while custom theme is being loaded.
		// Therefore, try a second time after 1 second.
		setTimeout(() => {
			dropdownElement = document.querySelector('.cta-main-container a.cta-dropdown-trigger');
			initDropdown(dropdownElement);
		}, 1000);
	}

	function initDropdown(trigger) {
		if (!trigger) {
			return;
		}

		trigger.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const parent = trigger.parentElement;
			const dropdown = parent.querySelector('.cta-dropdown');

			if (parent && !parent.classList.contains('show')) {
				parent.classList.add('show');

				const windowHeight = window.innerHeight;
				const dropdownHeight = dropdown.offsetHeight;
				const dropdownOffset = dropdown.getBoundingClientRect().top;

				// Check if dropdown is out of window, if so set max height
				if (dropdownOffset + dropdownHeight > windowHeight) {
					const maxHeight = windowHeight - dropdownOffset - 10; // 10px more just for a bit more space
					dropdown.style.height = maxHeight + 'px';
				}
			} else {
				if (parent) {
					parent.classList.remove('show');
				}

				if (dropdown) {
					dropdown.style.height = 'auto';
				}
			}
		});
	}
}
